// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

import BatteryFeatures from "@/db/BatteryFeatures/index.js";

// ## Battery Get
/**
 *
 * @param {{params: object, query: { batteryType: string, language: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const result = BatteryFeatures(option.query.batteryType);
  const response = {
    message: "OK",
    result: "OK",
    data: result,
  };
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Battery Create
/**
 *
 * @param {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": BatteryRole}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Battery.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {

  const response = {
    message: "OK",
    result: "OK",
    data: BatteryFeatures.find((item) => item.id === option.params.id),
  }; //await $api.get(Endpoints.BatteryFeatures.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Update
/**
 *
 * @param  {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": BatteryRole}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Battery.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Battery.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
